import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { DataGrid } from '@/components';
import { useDataGridColumns } from '@/components/DataGrid/hooks/useDataGridCols';
import {
  DataGridColSettings,
  mergeColumnSettings,
} from '@/components/DataGrid/utils';
import { LocalStoragePrefix } from '@/constants';
import { useBuildingInspectionContext } from '@/pages/Tools/BuildingInspection/BuildingInspectionContext';
import { useUserStore } from '@/store';
import { getLocalStorageItem } from '@/utils';

import { feesDataGridCols } from '../dummy_data/dummy_data';

export const FeesDataGrid = () => {
  const { user } = useUserStore();
  const { fees } = useBuildingInspectionContext();
  const { inspectionId } = useParams();
  const [columnSettings, setColumnSettings] = useState<DataGridColSettings[]>(
    () => {
      const savedSettings = getLocalStorageItem({
        key: String(user?._id),
        prefix: `fees-list-${LocalStoragePrefix.TableSetting}`,
        shouldParse: true,
      });

      if (!savedSettings) {
        return feesDataGridCols;
      }

      return mergeColumnSettings(feesDataGridCols, savedSettings);
    },
  );

  const handleDownload = () => {
    alert('download strarter');
  };
  const columns = useDataGridColumns({
    type: 'inspectionFeesCols',
    onEdit: handleDownload,
    columnSettings,
  }).map((column) => ({
    ...column,
    renderCell: (params: any) => {
      return column.renderCell ? column.renderCell(params) : params.value;
    },
  }));

  const fetchInspectionsFees = () => {
    return Promise.resolve({
      rows: fees.filter((item) => item.inspection_id === inspectionId),
    });
  };
  return (
    fees?.length && (
      <DataGrid
        hideFilter
        hideFooterPagination
        hideFooter
        key="inspectionFeesCols"
        name="fees-list"
        columnSettings={columnSettings}
        setColumnSettings={setColumnSettings}
        columns={columns}
        disableMultipleColumnsSorting={true}
        fetchData={fetchInspectionsFees}
        disableRowSelectionOnClick
        autoPageSize={false}
        rows={fees.filter((fee) => fee.inspection_id === inspectionId)}
        sx={{ maxHeight: '300px' }}
        slots={{ toolbar: null }}
      />
    )
  );
};
